/*
 * @Description:
 * @Author: Victor
 * @Date: 2023/02/07
 * @LastEditors: Victor
 * @LastEditTime: 2023-06-08 20:49:03
 */
import en_energyStorageList from './en-US/translation.json';
import zh_energyStorageList from './zh-CN/translation.json';
import ja_energyStorageList from './ja-JP/translation.json';
import de_energyStorageList from './de-DE/translation.json';
import nl_energyStorageList from './nl-NL/translation.json';
import it_energyStorageList from './it-IT/translation.json';
import sp_energyStorageList from './sp-SP/translation.json';
import el_energyStorageList from './el-GR/translation.json';
import fr_energyStorageList from './fr-FR/translation.json';
export const energyStorageList = {
  en_energyStorageList,
  zh_energyStorageList,
  ja_energyStorageList,
  de_energyStorageList,
  nl_energyStorageList,
  it_energyStorageList,
  sp_energyStorageList,
  fr_energyStorageList,
  el_energyStorageList,
};
